import moment from "moment-timezone";

export const getChannels = (dataSourceHandles, returnValue) => {
  let channels = [];

  dataSourceHandles.forEach((dataSourceHandle) => {
    const { trendsId, name } = dataSourceHandle;
    if (returnValue === "ids") {
      channels.push(trendsId);
    } else {
      let dataSource = {
        value: trendsId,
        name: name,
      };
      channels.push(dataSource);
    }
  });

  return channels;
};

export function removeIdTag(str) {
  return str.replace(/\s*\(#?\d+\)/, "");
}

export const buildWordCloudParams = ({
  orgTrendsId,
  dataSourceHandles,
  channelsId,
  startDate,
  endDate,
  direction,
}) => {

  const channels =
  channelsId?.length > 0 ? channelsId : getChannels(dataSourceHandles, "ids");

  if (!orgTrendsId || !channels?.length) return null;

  return {
    organizations: [orgTrendsId],
    channels,
    direction,
    startDate,
    endDate,
  };
};

export const buildSearchParams = ({
  filters,
  searchInput,
  dataSourceHandles,
  orgTrendsId,
}) => {
  const {
    direction,
    startDate,
    endDate,
    channels,
    offset = 0,
    page = 0,
  } = filters;

  const _channels =
    channels?.length > 0 ? channels : getChannels(dataSourceHandles, "ids");

  return {
    organizations: [orgTrendsId],
    channels: _channels,
    direction: direction,
    searchString: searchInput,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    offset,
    page,
    show: true,
  };
};

export const buildDerivedParams = (params) => {
  const start = params.startDate
    ? moment(params.startDate).startOf("day")
    : moment().startOf("year");

  const end = params.endDate ? moment(params.endDate).endOf("day") : moment();

  const channels = params.channels
    ? params.channels.split(",").map(Number)
    : [];

  return {
    startDate: start,
    endDate: end,
    channels,
    searchString: params.searchString || "",
    offset: Number(params.offset || 0),
    page: Number(params.page || 0),
    direction: params.direction || "INCOMING",
    view: params.view || "wordcloud",
  };
};
